import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import { __decorate } from "tslib";
import { Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
var Card = /*#__PURE__*/function (_Vue) {
  function Card() {
    var _this;
    _classCallCheck(this, Card);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Card, [].concat(args));
    _defineProperty(_this, "icon", void 0);
    _defineProperty(_this, "color", void 0);
    _defineProperty(_this, "label", void 0);
    return _this;
  }
  _inherits(Card, _Vue);
  return _createClass(Card, [{
    key: "loadingStyle",
    get: function get() {
      return "color: ".concat(this.color, ";");
    }
  }]);
}(Vue);
export { Card as default };
__decorate([Prop({
  default: ''
})], Card.prototype, "icon", void 0);
__decorate([Prop({
  default: '#666'
})], Card.prototype, "color", void 0);
__decorate([Prop({
  default: ''
})], Card.prototype, "label", void 0);